import React, { FC, PropsWithChildren, ReactNode } from "react";
import { Columns } from "../../components/containers/Columns";
import { Container } from "../../components/containers/Container";
import { PageIntro, PageIntroProps } from "../../components/PageIntro";

type Props = PropsWithChildren<{
  articleHeader: PageIntroProps;
  blocks?: ReactNode;
  videoBlock?: ReactNode;
}>;

export const Article: FC<Props> = ({ articleHeader, videoBlock, blocks, children }) => (
  <main className="block pt-[5.875rem]">
    <div className="block mb-xxl desktop:mb-xxxl">
      <PageIntro {...articleHeader} />
    </div>
    <Container>
      <Columns colSize="full" desktopColSize="6/12" justify="justify-center">
        <article className="block [&>*:first-child]:mt-0 mb-xxl desktop:mb-xxxl text-secondary-400">
          {videoBlock && (
            <div className="block my-xxl desktop:my-xxxl desktop:-mx-[18%]">
              {videoBlock}
            </div>
          )}
          {children}
        </article>
      </Columns>
    </Container>
    {blocks && <aside className="block mb-xxl desktop:mb-xxxl">{blocks}</aside>}
  </main>
);
